import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Button from 'components/common/Button/Button';
import Icon from 'components/mweb/Icon/Icon';
import MembershipPlan from 'components/mweb/HalalboxPrime/MembershipPlan';
import MembershipTermsAndCondition from 'components/mweb/HalalboxPrime/MembershipTermsAndCondition';

import { useHBPrimeData } from 'hb-redux-store/feature/halalboxPrime/hbPrime.hooks';
import {
  HALALBOX_TEXT,
  SELECT_PLAN_TEXT,
  Select_TEXT,
  TNC,
  TNC_DESCRIPTION,
} from 'hb-redux-store/constants/halalboxPrime';
import history from 'hb-redux-store/history';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';

import './halalbox-prime.scss';
import HBPrimeImage from 'assets/halalbox-prime/hb-prime-landing.svg';
import CartHBPrimeImage from 'assets/halalbox-prime/desktop-hb-prime-landing.png';
import MembershipCTA from 'components/mweb/HalalboxPrime/MembershipCTA';

const HalalboxPrime = ({ source = 'HOME', onCancel = () => {} }) => {
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;
  const [selectedPlan, setSelectedPlan] = useState();
  const {
    hbPrimeStore: { loading, hbPrimeMembershipDetail },
  } = useHBPrimeData(true);

  const showDetails = {
    HOME: {
      showFaq: true,
      showCloseButton: false,
      showBackButton: true,
      showBackgroundColor: true,
    },
    CART: {
      showFaq: false,
      showCloseButton: true,
      showBackButton: false,
      showBackgroundColor: false,
    },
  };

  const {
    membershipDescription,
    membershipPlans,
    tncTitle,
    tncDescription,
  } = hbPrimeMembershipDetail;
  const showTermsAndCondition =
    showDetails[source]?.showFaq && tncDescription?.length;

  useEffect(() => {
    if (membershipPlans && membershipPlans?.length) {
      membershipPlans.forEach(element => {
        if (element?.isSelected) setSelectedPlan(element);
      });
    }
  }, [membershipPlans]);

  return (
    <>
      {loading && <Loader />}

      <div
        className={`hb-prime main-content ${
          showDetails[source]?.showBackgroundColor ? 'background-color' : ''
        }`}
      >
        <div>
          {isMobileDevice ? (
            <div className="hb-prime-img-container">
              <img src={HBPrimeImage} className="hb-prime-img" />
              <div className="hb-prime--hb-prime-title">
                <div>{HALALBOX_TEXT}</div>
                <div>{Select_TEXT}</div>
              </div>
            </div>
          ) : (
            <img src={CartHBPrimeImage} className="hb-prime-img" />
          )}
          {showDetails[source]?.showCloseButton && (
            <Icon
              class="icon-common-close-white hb-prime-close-icon "
              size={30}
              onClick={() => onCancel()}
            />
          )}
          {showDetails[source]?.showBackButton && (
            <Icon
              class="icon-back-bar-back-white hb-prime-back"
              size={22}
              onClick={() => history.goBack()}
            />
          )}
        </div>
        <div className="hb-prime-membership-description-container">
          <div className="hb-prime membership-description">
            {membershipDescription}
          </div>

          {membershipPlans?.length && (
            <div className="hb-prime--membership-plan-wrapper">
              <span className="hb-prime-heading-text">{SELECT_PLAN_TEXT}</span>
              <div
                className={` ${
                  !isMobileDevice ? 'hb-prime--membership-alignment' : ''
                }`}
              >
                <MembershipPlan
                  data={membershipPlans}
                  selectedPlan={selectedPlan}
                  updateSelectedPlan={data => setSelectedPlan(data)}
                />
              </div>
            </div>
          )}

          {showTermsAndCondition && (
            <div className="hb-prime--faq-container">
              <MembershipTermsAndCondition
                data={tncDescription}
                tncTitle={tncTitle}
              />
            </div>
          )}
          <div className="hb-prime--tnc-container">
            <span className="hb-prime--more-info-text">{TNC_DESCRIPTION}</span>
            <Link
              to="/help/tnc#vxl-select"
              className="button action-link hb-prime--tnc-link"
            >
              {TNC}
            </Link>
          </div>
          <MembershipCTA
            source={source}
            selectedPlan={selectedPlan}
            containerStyle="hb-prime-bottom-sticky-cta"
            onCancel={onCancel}
          />
        </div>
      </div>
    </>
  );
};

export default HalalboxPrime;
